import { render, staticRenderFns } from "./StudentDetailDialog.vue?vue&type=template&id=228b18af&scoped=true"
import script from "./StudentDetailDialog.vue?vue&type=script&lang=js"
export * from "./StudentDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./StudentDetailDialog.vue?vue&type=style&index=0&id=228b18af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228b18af",
  null
  
)

export default component.exports